<div class="dialog-loading" *ngIf="(loading$ | async)">
    <mat-spinner diameter="36"></mat-spinner>
</div>
<div class="dialog-title-content">
    <div class="dialog-title">{{ 'modules.billing.companies.companyDialog.title' | translate }}</div>
    <div class="dialog-close" (click)="closeDialog(false)">
        <mat-icon>close</mat-icon>
    </div>
</div>
<div class="dialog-content tab-container">

    <form [formGroup]="companyForm" class="dialog-form scroll-content-padding df-c gap15" autocomplete="off">
        <div class="df gap20">
            <mat-form-field appearance="outline" floatLabel="always" class="no-padding full-width" style="width: 200px; min-width: 200px; max-width: 200px;">
                <mat-label>{{ 'modules.billing.companies.companyDialog.labels.type' | translate }}</mat-label>
                <mat-select class="select-panel" panelClass="dialog-select-panel" disableOptionCentering="true" formControlName="type">
                    <mat-option [value]="'LEGAL'">{{ 'modules.billing.companies.companyTypes.LEGAL' | translate }}</mat-option>
                    <mat-option [value]="'INDIVIDUAL'">{{ 'modules.billing.companies.companyTypes.INDIVIDUAL' | translate }}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" floatLabel="always" class="no-padding full-width">
                <mat-label>{{ 'modules.billing.companies.companyDialog.labels.code' | translate }}</mat-label>
                <input type="text" matInput formControlName="code">
            </mat-form-field>

            <div *ngIf="companyForm.get('type')?.value == 'LEGAL'"
                 style="padding-top: 12px"
                 (click)="fillByCode()"
                 matTooltip="Заповнити по коду"
                 matTooltipClass="tooltip"
            >
                <mat-icon class="primary-icon">content_paste_go</mat-icon>
            </div>
        </div>

        <mat-form-field appearance="outline" floatLabel="always" class="no-padding full-width">
            <mat-label>{{ 'modules.billing.companies.companyDialog.labels.name' | translate }}</mat-label>
            <input type="text" matInput formControlName="name">
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always" class="no-padding full-width">
            <mat-label>{{ 'modules.billing.companies.companyDialog.labels.address' | translate }}</mat-label>
            <input type="text" matInput formControlName="address">
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always" class="no-padding full-width">
            <mat-label>{{ 'modules.billing.companies.companyDialog.labels.director' | translate }}</mat-label>
            <input type="text" matInput formControlName="director">
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always" class="no-padding full-width">
            <mat-label>{{ 'modules.billing.companies.companyDialog.labels.directorPosition' | translate }}</mat-label>
            <input type="text" matInput formControlName="directorPosition">
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always" class="no-padding full-width">
            <mat-label>{{ 'modules.billing.companies.companyDialog.labels.directorPositionPersonal' | translate }}</mat-label>
            <input type="text" matInput formControlName="directorPositionPersonal">
        </mat-form-field>

        <autocomplete-item-field [required]="true"
                                 [dataType]="'MANAGER'"
                                 label="{{'modules.crm.contacts.contactDialog.labels.manager' | translate}}"
                                 formControlName="manager">
        </autocomplete-item-field>
    </form>

</div>

<div class="buttons-row df jc-e ai-c">
    <button class="default-button apply-button" [disabled]="companyForm.invalid" (click)="submitForm()">
        {{ 'common.save' | translate }}
    </button>
</div>
